module.exports = __webpack_public_path__ + "img/Like-Outline.f59c0d59.svg";